import { encoding } from '../../../modules/core';

export default angular
  .module('doxy.realtime.common.services.publisherManager', [])
  .factory(
    'publisherManager',
    function (
      $q,
      $rootScope,
      $timeout,
      $window,
      photoFactory,
      $log,
      VideoProviderFactory
    ) {
      return {
        capturePhotoWithCrop(options) {
          return VideoProviderFactory.activeProvider
            .getImgData()
            .then((imageData) => {
              if (!options || !imageData) return imageData;
              return photoFactory.resizeCrop(imageData, options);
            });
        },

        b64toBlob(b64Data, contentType, sliceSize = 512) {
          return encoding.base64toBlob(b64Data, contentType, sliceSize);
        },

        getCachedCapture(resize) {
          const cacheData =
            VideoProviderFactory.activeProvider.getCachedImgData();
          return cacheData
            ? photoFactory.resizeCrop(cacheData, resize)
            : Promise.resolve(null);
        },
      };
    }
  ).name;
